
import { Dispatch } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { TableThingyActions } from "../actions/table_actions";
import {News} from "../typing/table_typing";
import { myfetchThunk } from "../../../app/myfetch";
import {masteruri} from "../../../config";


interface licenseResponsePayloadInterface{
    news:News[],
}

export const requestDataFromAPI =() => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{       
        dispatch(myfetchThunk(
            true,
            masteruri+"/NewsManager",
            {},
            "GET",
            (payload:licenseResponsePayloadInterface) => {
                dispatch(
                     TableThingyActions.resetData(
                         {
                             data : payload.news,
                         }
                     )
                 );
                 
            },
            ()=>{}
        ) as any)
    }
}



export const publishNews =(news:News[]) => {
    console.log(news)
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{       
        dispatch(myfetchThunk(
            true,
            masteruri+"/NewsManager/select",
            {feedlist:news.map((element) => {
                return(
                    {
                        uuid:element.uuid,
                        delete:element.todelete,
                        selected:element.selected
                }
                )
            })
            },
            "POST",
            () => dispatch(requestDataFromAPI() as any),
            () => {},
            // The hub answers 204. Reload once the choice is stored - a fixed
            // 400 ms timer fired before the ~900 ms request had finished and
            // showed the old state.
            () => dispatch(requestDataFromAPI() as any),
        ) as any)
        // dispatch(
        //     TableThingyActions.resetData(
        //         {
        //             data : [] as News[],
        //         }
        //     )
        // );
        
      
    }
}
